import { mapValues, sortBy } from 'lodash-es';

import { sanitizeRichText } from 'components/form/richtext/RichTextInput';

import { Backend } from 'api/endpoints';

import { EASMultilanguage } from './EASTypes';

export const isOfferActive = (
	offer?: Pick<Backend.Offer, 'isVisible' | 'validTo'>,
) => {
	if (!offer || !('isVisible' in offer)) {
		return true;
	}
	return (
		offer.isVisible && new Date(offer.validTo).getTime() > new Date().getTime()
	);
};

export const getHardskillName = (
	hs?: Backend.StudentHardskill | Backend.OfferHardskill | null,
): EASMultilanguage => {
	if (!hs) {
		return {};
	}
	return hs?.hardskill?.multiName ?? hs?.suggestedHardskill?.multiName ?? {};
	// TODO: Fix
	// return n[0].toLocaleUpperCase() + n.slice(1);
};

export const sanitizeFormRichText = (
	obj: Pick<
		Backend.Company | Backend.Offer | Backend.Student,
		'descriptionPages'
	>,
) => ({
	descriptionPages: obj.descriptionPages
		? sortBy(obj.descriptionPages, 'order').map((dp, index) => ({
				...dp,
				order: index,
				content: mapValues(dp.content, sanitizeRichText),
		  }))
		: [],
});
